export default __webpack_public_path__ + "static/media/Strangler's Bracers of Arcane Death.84eaae78.jpg";